
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../components/CustomText";
import AccessibleCard from "../../components/cards/AccessibleCard";
import CardTitle from "../../components/cards/AccessibleprincipleCard";
import tick from "../../assets/tick.svg";
import accessible1 from "../../assets/accessible1.svg";
import accessible2 from "../../assets/accessible2.svg";
import accessible3 from "../../assets/accessible3.svg";

const AccessibleMainSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));

  // Icons and colors separately from text
  const icons = [accessible1, accessible2, accessible3];
  const colors = ["#3EC1F399", "#72B6E6", "#5D7F91"];

  // Translated card text data
  const translatedCards = t("accessible_cards", { returnObjects: true });

  return (
    <>
      <Box
        sx={{
          marginTop: "20px",
          paddingTop: isMobile ? "150px" : "60px",
          paddingBottom: "80px",
          position: "relative",
          px: isMobile ? 2 : isTablet ? 2 : 4,
        }}
      >
        <div style={{ marginTop: isMobile ? "-120px" : "0px" }}>
          <CustomText
            style={{
              ...textStyles.h3,
              color: "#072533",
              maxWidth: "1200px",
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            {t("accessibility_mainSection_heading")}
          </CustomText>
        </div>

        <CustomText
          style={{
            ...textStyles.body2,
            color: "#868282",
            maxWidth: "1100px",
            textAlign: "center",
            margin: "0 auto",
            marginTop: "30px",
          }}
        >
          {t("accessibility_mainSection_subheading")}
        </CustomText>

        <Box sx={{
          mt: 6,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 4,
          px: isMobile ? 2 : 8,
        }}>
          {translatedCards.map((card, idx) => (
            <Box
              key={idx}
              sx={{
                borderRadius: 2,
                px: 2,
                py: 3,
                backgroundColor: "#fff",
                minWidth: 270,
                flex: "1 1 270px",
                maxWidth: 360,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                border: "1px solid #DFDFDF",
              }}
            >
              {/* Icon + Title */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 2,
                  mb: 1,
                  pl: 1,
                }}
              >
                <Box
                  component="img"
                  src={icons[idx]}
                  sx={{ width: "40px", height: "40px", objectFit: "contain" }}
                />
                <CardTitle {...card.titleParts} color={colors[idx]} />
              </Box>

              {/* Description */}
              <CustomText
                style={{
                  ...textStyles.body4,
                  textAlign: "left",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  marginTop: "6px",
                  color: "#868282",
                  fontSize: "16px",
                  lineHeight: "1.4",
                  fontWeight: 600,
                  fontFamily: "Nunito, sans-serif",
                }}
              >
                {card.description}
              </CustomText>

              {/* Bullet Points */}
              <Box
                sx={{
                  mt: 2,
                  pl: "10px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.2,
                }}
              >
                {card.points.map((point, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <Box
                      sx={{
                        mt: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <img
                        src={tick}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                        }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "14.5px",
                        color: "#5E5C5C",
                        fontFamily: "Nunito, sans-serif",
                        lineHeight: 1.5,
                      }}
                    >
                      {point}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};
export default AccessibleMainSection;
